import React, { useContext } from 'react'
import './productDisplay.css'
import Star_icon from '../Assets/star.png'
import { shopContext } from '../../Context/ShopContext'
const ProductDisplay = (props) => {
   
  const { product } = props
 
  const {addToCart}= useContext(shopContext)
  return (
    <div className='product_display'>
      <div className="product_display_left">
           <div className="productdisplay_img_list">
          <img src={product.image} alt="" />
          <img src={product.image} alt="" />
          <img src={product.image} alt="" />
          <img src={product.image} alt="" />
           </div>
        <div className="productdisplay_image">
          <img className='productdisplay_main_img' src={product.image} alt="" />

        </div>

      </div>
      <div className="product_display_right">
        <h1>{product.name}</h1>
        <div className="productdisplay_imag_star">
          <img src={Star_icon} alt="" />
          <img src={Star_icon} alt="" />
          <img src={Star_icon} alt="" />
          <img src={Star_icon} alt="" />
          <img src={Star_icon} alt="" />
          <p>(122)</p>
        </div>

        <div className="productdisplay_prices">
          <div className="productdisplay_prices_old">{product.old_price}</div>
          <div className="productdisplay_prices_new">{product.new_price}</div>

        </div>

        <div className="productdisplay_descriptions">
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Velit perspiciatis molestias ducimus, dolore temporibus, exercitationem iste blanditiis soluta voluptates,
          ab reprehenderit dolorem voluptate eius iure molestiae fugiat amet sit laborum?
        </div>
        <div className="productdisplay_sizes">
          <h1>select size</h1>
          <div className="productdisplay_sizes"></div>
          <div>S</div>
          <div>M</div>
          <div>XL</div>
          <div>XXL</div>

        </div>

        <button onClick={()=> addToCart(product.id)}>Add Cart</button>
        <div className="productdisplay_category">
          <span>Category:</span>Women,Tshirt,CropTop
        </div>
        <div className="productdisplay_category">
          <span>Tag:</span>Modern,Latest
        </div>
      </div>

    </div>

  )
}

export default ProductDisplay